import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { CrudBrandService } from "app/_services/MasterCrudOps/crud-brand.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserStatus } from "app/_models/user-status";
import { States } from "app/_models/states";
import { CommonservicesService } from "app/_services/commonservices.service";
import { Cities } from "app/_models/cities";
import { StateService } from "app/_services/state.service";
import { CrudInvProjectService } from "app/_services/MasterCrudOps/crud-inv-project.service";
declare const swal: any;

@Component({
  selector: "app-add-brand",
  templateUrl: "./add-inv-project.component.html",
  styleUrls: ["./add-inv-project.component.css"],
})
export class AddInvProjectComponent implements OnInit {
  addInvProjectForm: UntypedFormGroup;
  pageNumber: Number;
  pageSize: Number;

  constructor(
    private crudInvProjectService: CrudInvProjectService,
    private dialogRef: MatDialogRef<AddInvProjectComponent>,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.initilizeForm();
  }

  ngOnInit() {}

  initilizeForm() {
    this.addInvProjectForm = this.formBuilder.group({
      projectName: [null, [Validators.required]],
      description: [null, [Validators.required]],
    });
  }

  saveInvProject() {
    this.crudInvProjectService
      .saveInvProject(
        this.addInvProjectForm.value.projectName,
        this.addInvProjectForm.value.description
      )
      .subscribe(
        (data) => {
          if (data.didError) {
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          } else {
            swal({
              title: "",
              text: data.message,
              type: "success",
              confirmButtonClass: "btn btn-info",
            });
          }
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        },
        (error) => {
          const errorMessage =
            error.error?.title ||
            error.error ||
            "Something went wrong. Please contact admin.";
          swal({
            title: "",
            text: errorMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }
}
